import angularCookie from "dcb-angular-cookie-law/dist/angular-cookie-law.min.js";
export default "angular-cookie-law";


// WEBPACK FOOTER //
// ./src/ui/app/services/cookieLaw.js